import { PresetRuleEditorContainer } from './components/containers/PresetRuleEditorContainer';

const ShippingRulePresetEditor = () => <PresetRuleEditorContainer />;

export default ShippingRulePresetEditor;
